import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

const EmailVerified = (props) => {

  const query = new URLSearchParams(props.location.search);
  console.log('query',query);
  const actionCode = query.get('oobCode');
  console.log('actionCode',actionCode);
  var url = 'https://funily.page.link/openApp';//?purpose=verifyEmail&actionCode='+actionCode;
  console.log('url',url);

  return (
    <div style={styles.container}>
      <img src={require('../images/logo.png')} style={styles.logo} />
      <h1>Your email has been verified!</h1>
      <Button
        variant='raised'
        color='primary'
        style={{fontSize: 25,paddingTop:10}}
        onClick={() => window.location.href=url}
      >Go To App Now!</Button>
    </div>
  )
}

const width = window.innerWidth;
const height = window.innerHeight;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: height * 0.1
  },
  logo: {
    height: height * 0.2,
    width: height * 0.2,
    borderRadius: height * 0.1
  }
}

export default EmailVerified



// WEBPACK FOOTER //
// ./src/components/EmailVerified.component.js